import { SubscriptionDto } from 'gleblu-socket-api';

import { Subscription } from '../interfaces/Subscriptions';

export function fromDto(subscriptionDto: SubscriptionDto): Subscription {
  return {
    id: subscriptionDto.id,
    status: subscriptionDto.status,
    priceId: subscriptionDto.priceId,
    cancelAtPeriodEnd: subscriptionDto.cancelAtPeriodEnd,
    currentPeriodEnd: subscriptionDto.currentPeriodEnd,
  };
}
